<template>
  <div
    class="placeholder-content"
    :style="{
      height: height,
      width: width
    }"
  />
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '10px',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
};
</script>

<style lang="scss" scoped>
.placeholder-content {
  height: 205px;
  overflow: hidden;
  position: relative;

  // Animation
  animation-duration: 1.7s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeholderAnimate;
  background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%);
  background-size: 1300px; // Animation Area

  &_item {
    width: 100%;
    height: 20px;
    position: absolute;
    background: #fff;
    z-index: 2;

    &::after,
    &::before {
      width: inherit;
      height: inherit;
      content: '';
      position: absolute;
    }
  }
}

@keyframes placeholderAnimate {
  0% { background-position: -650px 0; }
  100% { background-position: 650px 0; }
}
</style>
